import React from 'react';
import { Text, Flex } from '@chakra-ui/react';
import ChartCard from './ChartCard';

interface RevenueAtRiskChartProps {
  businessIdentifier?: string;
}

const FONT_FAMILY = 'TT Interphases Pro, Inter, sans-serif';

const RevenueAtRiskChart: React.FC<RevenueAtRiskChartProps> = ({
  businessIdentifier,
}) => {
  return (
    <ChartCard title="Revenue at Risk" isLoading={false} error={null}>
      <Flex align="center" justify="center" minH="200px">
        <Text color="gray.400" fontSize="sm" fontFamily={FONT_FAMILY}>
          Coming Soon — Requires deal value data to accumulate. Data will appear as new conversations are processed
        </Text>
      </Flex>
    </ChartCard>
  );
};

export default RevenueAtRiskChart;
